export default "__VITE_ASSET__DQXfCKJY__"